"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.roomViewStore = exports.setLeaderReviewCount = exports.invalidateCompanyInfo = exports.setSecretFormData = exports.setLikeStates = exports.setIsSubscribe = exports.setSalesClosed = exports.setCustomDeliveryId = exports.deleteFromCart = exports.decreaseCartItemAmount = exports.setCartItemAmount = exports.increaseCartItemAmount = exports.addToCart = exports.setIsBlockUser = exports.setWhoAmI = exports.removeComment = exports.updateComment = exports.getComments = exports.getLeaderNotice = exports.getProductDataForSale = exports.getServerTime = exports.getRoomViewData = exports.getNonMemberRoomViewData = exports.getLoggedInUserRoomViewData = void 0;
const store_1 = __importDefault(require("@/store"));
const toolkit_1 = require("@reduxjs/toolkit");
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const errors_1 = require("@/common/errors");
const initialState = {
    deliveryType: '2',
    roomData: {
        ready: false,
        id: 0,
        is_leader_block_user: false,
        is_block_user: false,
        room_type_cd: 'ROOM_TYPE_00',
        img_url: null,
        start_date: '',
        end_date: '',
        startDateUnixTimestamp: 0,
        endDateUnixTimestamp: 0,
        room_status_cd: 'ROOM_STATUS_01',
        salesClosed: false,
        leader: 0,
        uid: '',
        leader_nick: '',
        leader_profile_img_url: '',
        title: null,
        fee_free: true,
        delivery_region: 'KR',
        paytype: 'login_required',
        second_paid: false,
        second_custom: false,
        support_delivery_date: '',
        deliveries: [],
        contents: '',
        refund_policy: '',
        tag: [],
        payment_approval_cd: 'ROOM_PAY_APPROVAL_STATUS_03',
        fonds: [],
        server_time: 0,
        is_question: false,
        review_count: 0,
        has_like: false,
        like_counts: 0,
        is_subscribe: false,
        notice: '',
        view_counts: 0,
        is_order_active: true,
        channel_activate_slot_count: 0,
        secret_hint: '', // ? 시크릿폼
    },
    productData: [],
    cart: [],
    customDeliveryId: 0,
    leaderNotice: [],
    comments: [],
    whoAmI: functions_1.initialWhoAmIData,
    regularSales: false,
    isDemandSurvey: false,
    isCommission: false,
};
const storeName = 'roomView';
const getParsedRoomViewDataset = () => {
    const rootDiv = document.getElementById('root');
    const dataset = rootDiv === null || rootDiv === void 0 ? void 0 : rootDiv.dataset.roomData;
    const isDatasetAvailable = dataset !== undefined && dataset !== '{}' && dataset !== '';
    if (isDatasetAvailable) {
        const parsedData = JSON.parse(dataset);
        if (parsedData.channel_id) {
            // ! Commission
            parsedData.leader = Number(parsedData.channel_id);
            parsedData.room_type_cd = 'ROOM_TYPE_04';
            delete parsedData.channel_id;
        }
        if (window.location.origin !== 'https://fondee.io')
            console.log('root div dataset: ', parsedData);
        return parsedData;
    }
    else
        return false;
};
exports.getLoggedInUserRoomViewData = (0, toolkit_1.createAsyncThunk)(`${storeName}/getLoggedInUserRoomViewData`, (confirm, { dispatch, rejectWithValue, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const parsedRoomViewData = getParsedRoomViewDataset();
    if (parsedRoomViewData) {
        return yield (0, api_1.getData)(`/api/v1/profile/${parsedRoomViewData.leader}/relation-status`)
            .then(res => {
            if (res.status === 200) {
                const { user_blocked: is_block_user, target_blocked: is_leader_block_user, is_subscribe, uid, thumbnail: leader_profile_img_url, name: leader_nick, comment: notice, company_info, } = res.data.result;
                const userRelationsData = {
                    is_block_user,
                    is_leader_block_user,
                    is_subscribe,
                    uid,
                    leader_profile_img_url,
                    leader_nick,
                    notice,
                    company_info,
                };
                const roomViewData = Object.assign(Object.assign({}, parsedRoomViewData), userRelationsData);
                const isAdmin = getState().whoAmI.is_admin;
                if (parsedRoomViewData.is_secret && !isAdmin) {
                    dispatch((0, exports.setSecretFormData)(roomViewData));
                }
                else {
                    dispatch((0, exports.getRoomViewData)(roomViewData));
                }
            }
            else {
                return rejectWithValue('rejected');
            }
        })
            .catch(() => rejectWithValue('rejected'));
    }
    else {
        const isForm = !window.location.pathname.includes('commission');
        (0, errors_1.notFoundConfirm)({ confirm, isForm });
    }
}));
exports.getNonMemberRoomViewData = (0, toolkit_1.createAsyncThunk)(`${storeName}/getNonMemberRoomViewData`, (confirm, { dispatch, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const parsedRoomViewData = getParsedRoomViewDataset();
    if (parsedRoomViewData) {
        return yield (0, api_1.getData)(`/api/v1/room/${parsedRoomViewData.id}/channel`)
            .then(res => {
            if (res.status === 200) {
                const { uid, thumbnail: leader_profile_img_url, name: leader_nick, comment: notice, company_info, } = res.data.result;
                const leaderInfoData = {
                    uid,
                    leader_profile_img_url,
                    leader_nick,
                    notice,
                    company_info,
                };
                const roomViewData = Object.assign(Object.assign({}, parsedRoomViewData), leaderInfoData);
                if (parsedRoomViewData.is_secret) {
                    dispatch((0, exports.setSecretFormData)(roomViewData));
                }
                else {
                    dispatch((0, exports.getRoomViewData)(roomViewData));
                }
            }
            else {
                return rejectWithValue('rejected');
            }
        })
            .catch(() => rejectWithValue('rejected'));
    }
    else {
        const isForm = !window.location.pathname.includes('commission');
        (0, errors_1.notFoundConfirm)({ confirm, isForm });
    }
}));
exports.getRoomViewData = (0, toolkit_1.createAsyncThunk)(`${storeName}/getRoomViewData`, (roomViewData) => __awaiter(void 0, void 0, void 0, function* () {
    const rootDiv = document.getElementById('root');
    rootDiv === null || rootDiv === void 0 ? true : delete rootDiv.dataset.roomData;
    if (window.location.origin !== 'https://fondee.io')
        console.log('roomViewData: ', roomViewData);
    return roomViewData;
}));
exports.getServerTime = (0, toolkit_1.createAsyncThunk)(`${storeName}/getServerTime`, () => __awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.getData)(`/api/v1/fonrympic/server-time`)
        .then(res => {
        if (res.status === 200) {
            return res.data;
        }
    })
        .catch(() => { });
}));
exports.getProductDataForSale = (0, toolkit_1.createAsyncThunk)(`${storeName}/getProductDataForSale`, (roomId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.getData)(`/api/v1/store/room-view/${roomId}/product`)
        .then(res => {
        if (res.status === 200) {
            return res.data.result;
        }
        else {
            return rejectWithValue('rejected');
        }
    })
        .catch(() => rejectWithValue('rejected'));
}));
exports.getLeaderNotice = (0, toolkit_1.createAsyncThunk)(`${storeName}/getLeaderNotice`, (roomId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.getData)(`/api/v1/store/room-view/${roomId}/leader-notice`)
        .then(res => {
        if (res.status === 200) {
            return res.data.result;
        }
        else {
            return rejectWithValue('rejected');
        }
    })
        .catch(() => rejectWithValue('rejected'));
}));
exports.getComments = (0, toolkit_1.createAsyncThunk)(`${storeName}/getComments`, (roomId, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    return yield (0, api_1.getData)(`/api/v1/store/room-view/${roomId}/comment`)
        .then(res => {
        if (res.status === 200) {
            return res.data.result;
        }
        else {
            return rejectWithValue('rejected');
        }
    })
        .catch(() => rejectWithValue('rejected'));
}));
exports.updateComment = (0, toolkit_1.createAsyncThunk)(`${storeName}/updateComment`, (arg, { getState, dispatch, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { commentId, commentData } = arg;
    const isNewComment = commentId.includes('new');
    const isQuestion = commentId.includes('question');
    const commentIdArr = commentId.split('_');
    const questionId = commentIdArr[1] || '';
    const answerId = commentIdArr[2] || '';
    // ? 새질문: roomId/comment
    // ? 질문 수정: roomId/comment/{questionId}
    // ! 새답변: roomId/comment/{questionId}/reply
    // ! 답변 수정: roomId/comment/{questionId}/reply/{answerId}
    const endPoint = (() => {
        if (isQuestion) {
            if (isNewComment)
                return ''; // ? isNewQuestion
            else
                return `/${questionId}`; // ? isEditQuestion
        }
        else {
            if (isNewComment)
                return `/${questionId}/reply`; // ! isNewReply
            else
                return `/${questionId}/reply/${answerId}`; // ! isEditReply
        }
    })();
    const updateData = isNewComment ? api_1.postData : api_1.patchData;
    const { roomData: { id: roomId }, } = getState();
    return yield updateData(`/api/v1/store/room-view/${roomId}/comment${endPoint}`, commentData)
        .then(res => {
        if (res.status === 201 || res.status === 200) {
            (0, functions_1.showToastMessage)({
                message: i18next_1.default.t(`${isQuestion ? '문의가' : '답글이'} ${isNewComment ? '등록' : '수정'}되었습니다.`),
            });
            dispatch((0, exports.getComments)(roomId));
        }
        else {
            return rejectWithValue('rejected');
        }
    })
        .catch(() => rejectWithValue('rejected'));
}));
exports.removeComment = (0, toolkit_1.createAsyncThunk)(`${storeName}/removeComment`, (arg, { getState, dispatch, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { commentId, setDeleting } = arg;
    setDeleting(true);
    const isQuestion = commentId.includes('question');
    const commentIdArr = commentId.split('_');
    const questionId = commentIdArr[1] || '';
    const answerId = commentIdArr[2] || '';
    // ? 질문 : 1/comment/77
    // ! 답변 : 1/comment/70/reply/74
    const endPoint = (() => {
        if (isQuestion) {
            return questionId; // ? isQuestion
        }
        else {
            return `${questionId}/reply/${answerId}`; // ! isReply
        }
    })();
    const { roomData: { id: roomId }, } = getState();
    return yield (0, api_1.deleteData)(`/api/v1/store/room-view/${roomId}/comment/${endPoint}`)
        .then(res => {
        if (res.status === 204) {
            (0, functions_1.showToastMessage)({
                message: i18next_1.default.t(isQuestion ? '문의가 삭제되었어요' : '답변이 삭제되었어요'),
            });
            dispatch((0, exports.getComments)(roomId));
        }
        else {
            setDeleting(false);
            return rejectWithValue('rejected');
        }
    })
        .catch(() => {
        setDeleting(false);
        return rejectWithValue('rejected');
    });
}));
const roomViewSlice = (0, toolkit_1.createSlice)({
    name: storeName,
    initialState,
    reducers: {
        setWhoAmI: (state, { payload }) => {
            state.whoAmI = payload;
        },
        setIsBlockUser: (state, { payload }) => {
            state.roomData.is_block_user = payload;
        },
        addToCart: (state, { payload: productIndex }) => {
            if (!state.whoAmI.is_logged_in)
                (0, functions_1.showToastMessage)({ message: i18next_1.default.t('로그인을 먼저 해주세요') });
            else {
                const productToAdd = state.productData[productIndex];
                const cartItemIndex = state.cart.findIndex(item => item.id === productToAdd.id);
                if (cartItemIndex === -1) {
                    state.cart.push(Object.assign(Object.assign({}, productToAdd), { amount: 1 }));
                    state.cart.sort((a, b) => a.id - b.id);
                }
            }
        },
        increaseCartItemAmount: (state, { payload }) => {
            const { amount, remain_stock: remainStock, purchase_limit } = state.cart[payload];
            /*
              ? 남은 재고 vs 구매제한개수: 더 작은 것 -> 사용자가 추가 가능한 최대 수량
              ? 남은 재고 = 구매제한개수일 경우: 구매제한개수 -> 사용자가 추가 가능한 최대 수량
              remainStock > purchaseLimit : purchaseLimit
              remainStock = purchaseLimit : purchaseLimit
              remainStock < purchaseLimit : remainStock
            */
            const isDemandSurvey = state.isDemandSurvey;
            const demandSurveyLimit = 100;
            const purchaseLimit = isDemandSurvey
                ? Math.min(demandSurveyLimit, purchase_limit)
                : purchase_limit;
            const isLimitTypeStock = remainStock < purchaseLimit;
            const amountLimit = Math.min(remainStock, purchaseLimit);
            if (amount >= amountLimit) {
                const limitMessage = isLimitTypeStock
                    ? i18next_1.default.t('작품의 재고가 remainStock개 남았습니다', { remainStock })
                    : i18next_1.default.t('1인당 구매개수를 초과했어요');
                (0, functions_1.showToastMessage)({ message: limitMessage });
                state.cart[payload] = Object.assign(Object.assign({}, state.cart[payload]), { amount: amountLimit });
            }
            else
                state.cart[payload].amount += 1;
        },
        setCartItemAmount: (state, { payload }) => {
            if (!state.whoAmI.is_logged_in)
                (0, functions_1.showToastMessage)({ message: i18next_1.default.t('로그인을 먼저 해주세요') });
            else {
                const { productIndex, cartItemIndex, inputNum } = payload;
                if (inputNum <= 0)
                    state.cart[cartItemIndex] = Object.assign(Object.assign({}, state.cart[cartItemIndex]), { amount: 1 });
                else {
                    const isInCart = typeof productIndex !== 'number';
                    const { remain_stock: remainStock, purchase_limit } = isInCart
                        ? state.cart[cartItemIndex]
                        : state.productData[productIndex];
                    const isDemandSurvey = state.isDemandSurvey;
                    const demandSurveyLimit = 100;
                    const purchaseLimit = isDemandSurvey
                        ? Math.min(demandSurveyLimit, purchase_limit)
                        : purchase_limit;
                    const isLimitTypeStock = remainStock < purchaseLimit;
                    const amountLimit = Math.min(remainStock, purchaseLimit);
                    if (inputNum > amountLimit) {
                        const limitMessage = isLimitTypeStock
                            ? i18next_1.default.t('작품의 재고가 remainStock개 남았습니다', { remainStock })
                            : i18next_1.default.t('1인당 구매개수를 초과했어요');
                        (0, functions_1.showToastMessage)({ message: limitMessage });
                        if (isInCart)
                            state.cart[cartItemIndex] = Object.assign(Object.assign({}, state.cart[cartItemIndex]), { amount: amountLimit });
                        else {
                            state.cart.push(Object.assign(Object.assign({}, state.productData[productIndex]), { amount: amountLimit }));
                            state.cart.sort((a, b) => a.id - b.id);
                        }
                    }
                    else {
                        if (isInCart)
                            state.cart[cartItemIndex] = Object.assign(Object.assign({}, state.cart[cartItemIndex]), { amount: inputNum });
                        else {
                            state.cart.push(Object.assign(Object.assign({}, state.productData[productIndex]), { amount: inputNum }));
                            state.cart.sort((a, b) => a.id - b.id);
                        }
                    }
                }
            }
        },
        decreaseCartItemAmount: (state, { payload }) => {
            if (state.cart[payload].amount <= 1)
                return;
            else
                state.cart[payload].amount -= 1;
        },
        deleteFromCart: (state, { payload }) => {
            state.cart.splice(payload, 1);
        },
        setCustomDeliveryId: (state, { payload }) => {
            state.customDeliveryId = payload;
        },
        setSalesClosed: (state, { payload }) => {
            state.roomData.salesClosed = payload;
        },
        setIsSubscribe: (state, { payload }) => {
            state.roomData.is_subscribe = payload;
        },
        setLikeStates: (state, { payload }) => {
            state.roomData.has_like = payload;
            state.roomData.like_counts = state.roomData.like_counts + (payload ? 1 : -1);
        },
        setSecretFormData: (state, { payload }) => {
            state.roomData = payload;
            // ? "누구나 구매할 수 있나요?" data parsing
            switch (payload.payment_approval_cd) {
                case 'ROOM_PAY_APPROVAL_STATUS_00':
                    state.roomData.paytype = 'parental_consent';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_01':
                    state.roomData.paytype = 'certified_required';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_02':
                    state.roomData.paytype = 'adult_only';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_03':
                    state.roomData.paytype = 'login_required';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_04':
                    state.roomData.paytype = 'under_14';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_05':
                    state.roomData.paytype = 'adult_plus';
                    break;
            }
            state.roomData.ready = 'password_required';
        },
        invalidateCompanyInfo: state => {
            state.roomData.company_info = undefined;
        },
        setLeaderReviewCount: (state, { payload }) => {
            state.roomData.review_count = payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(exports.getLoggedInUserRoomViewData.rejected, () => {
            alert((0, errors_1.commonErrorMsg)());
        });
        builder.addCase(exports.getNonMemberRoomViewData.rejected, () => {
            alert((0, errors_1.commonErrorMsg)());
        });
        builder.addCase(exports.getRoomViewData.fulfilled, (state, { payload }) => {
            var _a, _b;
            state.roomData = payload;
            // ? initialize salesClosed
            if (payload.room_status_cd === 'ROOM_STATUS_06') {
                state.roomData.salesClosed = true;
            }
            else {
                state.roomData.salesClosed = false;
            }
            // ? 상시판매인지 아닌지 설정
            state.regularSales = payload.room_type_cd === 'ROOM_TYPE_01';
            // ? 수요조사인지 아닌지 설정
            state.isDemandSurvey = payload.room_type_cd === 'ROOM_TYPE_03';
            const isCommission = payload.room_type_cd === 'ROOM_TYPE_04';
            if (isCommission) {
                state.isCommission = true;
            }
            else {
                // ? 날짜 현지화 logic
                const { start_date, end_date, support_delivery_date } = payload;
                state.roomData.start_date = (0, string_utils_1.changeKSTToLocalTime)(start_date);
                const ONE_SEC = 1000; // ms
                state.roomData.startDateUnixTimestamp = (0, string_utils_1.getUnixTimestampFromKSTTime)(start_date) + ONE_SEC;
                state.roomData.end_date = (0, string_utils_1.changeKSTToLocalTime)(end_date);
                state.roomData.endDateUnixTimestamp = (0, string_utils_1.getUnixTimestampFromKSTTime)(end_date);
                state.roomData.support_delivery_date = (0, string_utils_1.changeKSTToLocalTime)(support_delivery_date);
                // ? 배송비 data parsing (START) : room_create/preview/Shipping.tsx 컴포넌트 재사용하기 위함.
                // ! delivery_option_cd: 'DELIVERY_TYPE_01' | 'DELIVERY_TYPE_00' | 'DELIVERY_TYPE_03' | 'DELIVERY_TYPE_02' | 'DELIVERY_TYPE_04' | 'DELIVERY_TYPE_05'
                //                                무료       |        고정         |        조건부        |     구매개수별 차등    |      도서산간추가     |    구매자 맞춤 배송
                // ? delivery_type(number):        2        |         1          |          4         |          3         |          5         |         6
                let deliveryArr = [];
                let isCustomDelivery = false;
                payload.deliveries.forEach((item) => {
                    const { origin_price, price: delivery_price, condition: number, delivery_option_cd, name, id, } = item;
                    switch (delivery_option_cd) {
                        case 'DELIVERY_TYPE_01':
                            state.deliveryType = '2';
                            deliveryArr.push({ delivery_type: 2, origin_price, delivery_price });
                            break;
                        case 'DELIVERY_TYPE_00':
                            state.deliveryType = '1';
                            deliveryArr.push({ delivery_type: 1, origin_price, delivery_price });
                            break;
                        case 'DELIVERY_TYPE_03':
                            state.deliveryType = '4';
                            deliveryArr.push({ delivery_type: 4, origin_price, delivery_price, number });
                            break;
                        case 'DELIVERY_TYPE_02':
                            if (state.deliveryType !== '3')
                                state.deliveryType = '3';
                            deliveryArr.push({ delivery_type: 3, origin_price, delivery_price, number });
                            break;
                        case 'DELIVERY_TYPE_04':
                            deliveryArr.push({ delivery_type: 5, origin_price, delivery_price });
                            break;
                        case 'DELIVERY_TYPE_05':
                            if (state.deliveryType !== '6')
                                state.deliveryType = '6';
                            if (!isCustomDelivery)
                                isCustomDelivery = true;
                            deliveryArr.push({
                                delivery_type: 6,
                                origin_price,
                                delivery_price,
                                name,
                                number,
                                id,
                            });
                            break;
                    }
                });
                state.roomData.deliveries = deliveryArr.sort((a, b) => {
                    if (a.delivery_type && b.delivery_type) {
                        if (a.delivery_type - b.delivery_type > 0) {
                            return 1;
                        }
                        else if (a.delivery_type - b.delivery_type === 0) {
                            if (a.number && b.number) {
                                return a.number - b.number;
                            }
                            else {
                                return 0;
                            }
                        }
                        else {
                            return -1;
                        }
                    }
                    else {
                        return -1;
                    }
                });
                // ? 페이지 reload O -> reload 전에 담겨있던 커스텀 배송비
                // ? 페이지 reload X -> 가장 비싼 커스텀 배송비를 default로 설정
                if (isCustomDelivery) {
                    const prevCustomDeliveryId = (0, functions_1.getSearchParam)('custom');
                    if (prevCustomDeliveryId) {
                        state.customDeliveryId = Number(prevCustomDeliveryId);
                    }
                    else {
                        let max = -1;
                        let targetIndex = 0;
                        deliveryArr.forEach((delivery, index) => {
                            if ((delivery === null || delivery === void 0 ? void 0 : delivery.delivery_type) === 6 &&
                                typeof delivery.delivery_price == 'number' &&
                                max < (delivery === null || delivery === void 0 ? void 0 : delivery.delivery_price)) {
                                max = delivery === null || delivery === void 0 ? void 0 : delivery.delivery_price;
                                targetIndex = index;
                            }
                        });
                        state.customDeliveryId = ((_a = deliveryArr[targetIndex]) === null || _a === void 0 ? void 0 : _a.id) || 0;
                    }
                }
                // ? 배송비 data parsing (END)
                // ? get category data from fonds data
                state.roomData.category = (_b = payload.fonds[0]) === null || _b === void 0 ? void 0 : _b.fond;
                // ? initialize server_time
                state.roomData.server_time = 0;
            }
            state.roomData.contents = (0, functions_1.getCdnUrl)(payload.contents);
            // ? "누구나 구매할 수 있나요?" data parsing
            switch (payload.payment_approval_cd) {
                case 'ROOM_PAY_APPROVAL_STATUS_00':
                    state.roomData.paytype = 'parental_consent';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_01':
                    state.roomData.paytype = 'certified_required';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_02':
                    state.roomData.paytype = 'adult_only';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_03':
                    state.roomData.paytype = 'login_required';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_04':
                    state.roomData.paytype = 'under_14';
                    break;
                case 'ROOM_PAY_APPROVAL_STATUS_05':
                    state.roomData.paytype = 'adult_plus';
                    break;
            }
            state.roomData.ready = true;
        });
        builder.addCase(exports.getServerTime.fulfilled, (state, { payload }) => {
            state.roomData.server_time = payload;
        });
        builder.addCase(exports.getProductDataForSale.fulfilled, (state, { payload }) => {
            const prevCartParams = (0, functions_1.getSearchParam)('cart');
            const prevCart = prevCartParams ? JSON.parse(prevCartParams) : null;
            const cartIsInitialized = state.cart.length === 0;
            payload.forEach((productItem) => {
                const { id: productItemId, remain_stock: remainStock, purchase_limit } = productItem;
                // ? 페이지 reload X -> 원래 담겨있던 카트아이템 index
                const cartItemIndex = state.cart.findIndex(cartItem => cartItem.id === productItemId);
                // ? 페이지 reload O -> reload 전에 담겨있던 카트 정보
                const prevCartItemInfo = prevCart &&
                    prevCart.find(({ id: prevCartItemId }) => prevCartItemId === productItemId);
                const isSoldOut = remainStock <= 0;
                productItem.isSoldOut = isSoldOut;
                const isDemandSurvey = state.isDemandSurvey;
                const demandSurveyLimit = 100;
                const purchaseLimit = isDemandSurvey
                    ? Math.min(demandSurveyLimit, purchase_limit)
                    : purchase_limit;
                const amountLimit = Math.min(remainStock, purchaseLimit);
                if (cartItemIndex !== -1) {
                    const cartItemAmount = state.cart[cartItemIndex].amount;
                    if (isSoldOut)
                        state.cart.splice(cartItemIndex, 1);
                    else if (!isSoldOut && cartItemAmount > amountLimit) {
                        state.cart[cartItemIndex] = Object.assign(Object.assign({}, productItem), { amount: amountLimit });
                    }
                }
                else if (cartIsInitialized && prevCartItemInfo && !isSoldOut) {
                    const amount = Math.min(amountLimit, prevCartItemInfo.amount);
                    state.cart.push(Object.assign(Object.assign({}, productItem), { amount }));
                }
            });
            state.productData = payload;
            window.history.replaceState(null, '', `?room_id=${state.roomData.id}`);
        });
        builder.addCase(exports.getProductDataForSale.rejected, () => {
            alert(`${i18next_1.default.t('앗, 인터넷 연결이 불안정해요!')} ${i18next_1.default.t('작품을 불러오기 위해 새로고침 해주세요')}:)`);
        });
        builder.addCase(exports.getLeaderNotice.fulfilled, (state, { payload }) => {
            state.leaderNotice = payload;
        });
        builder.addCase(exports.getLeaderNotice.rejected, () => {
            alert(`${i18next_1.default.t('앗, 인터넷 연결이 불안정해요!')} ${i18next_1.default.t('공지사항을 불러오기 위해 새로고침 해주세요')}:)`);
        });
        builder.addCase(exports.getComments.fulfilled, (state, { payload }) => {
            state.comments = payload;
        });
        builder.addCase(exports.getComments.rejected, () => {
            alert(`${i18next_1.default.t('앗, 인터넷 연결이 불안정해요!')} ${i18next_1.default.t('문의/답변을 불러오기 위해 새로고침 해주세요')}:)`);
        });
        builder.addCase(exports.updateComment.rejected, () => {
            alert(i18next_1.default.t('작품 문의/답변 실패'));
        });
        builder.addCase(exports.removeComment.rejected, () => {
            alert(i18next_1.default.t('문의/답변 삭제 실패'));
        });
    },
});
_a = roomViewSlice.actions, exports.setWhoAmI = _a.setWhoAmI, exports.setIsBlockUser = _a.setIsBlockUser, exports.addToCart = _a.addToCart, exports.increaseCartItemAmount = _a.increaseCartItemAmount, exports.setCartItemAmount = _a.setCartItemAmount, exports.decreaseCartItemAmount = _a.decreaseCartItemAmount, exports.deleteFromCart = _a.deleteFromCart, exports.setCustomDeliveryId = _a.setCustomDeliveryId, exports.setSalesClosed = _a.setSalesClosed, exports.setIsSubscribe = _a.setIsSubscribe, exports.setLikeStates = _a.setLikeStates, exports.setSecretFormData = _a.setSecretFormData, exports.invalidateCompanyInfo = _a.invalidateCompanyInfo, exports.setLeaderReviewCount = _a.setLeaderReviewCount;
exports.roomViewStore = (0, store_1.default)(roomViewSlice.reducer);
